__webpack_require__.p = "https://assets.ugv.skeepers.io/capture/";